import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Shell.css';

export default function Shell({ children, rightSlot }) {
  return (
    <div className="rrm-shell">
      <div className="rrm-shell-top">
        <div className="rrm-shell-brand">RRMonitor</div>
        <div className="rrm-shell-right">
          {rightSlot}
          <button className="rrm-shell-signout" type="button" onClick={() => signOut(auth)}>
            Sign out
          </button>
        </div>
      </div>
      <div className="rrm-shell-content">{children}</div>
    </div>
  );
}


